// Author Lin
// Date 2022-06-15 17:03:39

class SithMesInventoryManualOutput {
constructor({
        id = null,
        manualCheckId = '',
        outputQuantity = '',
        outputTime = '',
        outputLogin = '',
        materialDestination = '',
        remark = ''}
= {}) {
    this.id = id;
    this.manualCheckId = manualCheckId;
    this.outputQuantity = outputQuantity;
    this.outputTime = outputTime;
    this.outputLogin = outputLogin;
    this.materialDestination = materialDestination;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryManualOutput();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'manualCheckId',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.manualCheckId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'outputQuantity',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.outputQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'outputTime',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.outputTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'outputLogin',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.outputLogin',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'outputName',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.outputName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialDestination',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.materialDestination',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    manualCheckIdFilter : '',
    outputQuantityFilter : '',
    outputTimeRteFilter : '',
    outputTimeLteFilter : '',
    outputLoginFilter : '',
    materialDestinationFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'manualCheckIdFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.manualCheckId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesInventoryManualCheck'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'outputQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.outputQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'outputTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.outputTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'outputTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.outputTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'outputLoginFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.outputLogin',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'materialDestinationFilter',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.filter.materialDestination',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'manualCheckId',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.manualCheckId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesInventoryManualCheck'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'outputQuantity',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.outputQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'outputTime',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.outputTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'outputLogin',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.outputLogin',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'materialDestination',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.materialDestination',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualOutput.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryManualOutput, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
